module.exports = __webpack_public_path__ + "img/acero-corten.1aa6c070.jpg";